<template>
  <div>
    <page-main
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :disabled="disabled"
      @reload="getData"
    >
      <div slot="header" class="order-goods-table-header">
        <div class="side-frame-warning">
          <span class="side-frame-text">
            {{ $l('table_header_orderGoods') || '订单产品' }}
          </span>
          <el-divider direction="vertical"></el-divider>
          <span>
            {{
              `Notice: ${order.noticeByName || '--'} at ${order.noticeTime ||
                '--'}`
            }}
          </span>
          <el-divider direction="vertical"></el-divider>
          <b-button
            class="mr-2 ml-2"
            size="sm"
            variant="outline-success"
            @click="ncComplete()"
            v-if="disabled"
          >
            {{ $l('btn_ncComplete') || '赋码完成确认' }}
          </b-button>
          <b-button
            class="mr-2 ml-2"
            size="sm"
            variant="outline-primary"
            @click="() => (visible = true)"
            v-if="disabled"
          >
            {{ $l('dialog_title_batch_update_nc_no') || '批量更新NC编码' }}
          </b-button>
        </div>
        <div style="display: flex;align-items: center;margin-right: 12px;">
          <vxe-button @click="$refs.main.setAllTreeExpand()" circle>
            <i class="fa fa-angle-double-down" style="font-size: 16px;" />
          </vxe-button>
          <vxe-button @click="$refs.main.clearTreeExpand()" circle>
            <i class="fa fa-angle-double-up" style="font-size: 16px;" />
          </vxe-button>
        </div>
      </div>
    </page-main>
    <BatchUpdateNcNo
      v-if="visible"
      :title="$l('dialog_title_batch_update_nc_no') || '批量更新NC编码'"
      :visible.sync="visible"
      :noticeOrderCode="noticeOrderCode"
      @confirm="() => getData()"
    />
  </div>
</template>
<script>
import PageMain from './main'
import BatchUpdateNcNo from '../batch-update-ncNo'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  components: { PageMain, BatchUpdateNcNo },
  props: {
    disabled: { type: Boolean, default: false },
    noticeOrderCode: { type: String, default: '' },
    order: { type: Object, default: () => {} },
  },
  data() {
    return {
      visible: false,
      loading: false,
      tableData: [],
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.noticeOrderCode) return
      this.tableData = []
      this.loading = true
      const res = await this.$api
        .noticeOrderGoodsTreeApi({ noticeOrderCode: this.noticeOrderCode })
        .catch(() => null)
      this.loading = false
      if (!res) return
      const data = res.body.data || []
      this.tableData = data.map((item) => ({ ...item, oldNcNo: item.ncNo }))
      setTimeout(() => {
        this.$refs.main.setAllTreeExpand()
      }, 0)
    },
    async ncComplete() {
      // 校验表格数据
      const result = await this.$refs.main.validate()
      if (!result) {
        this.$message.error(
          this.$l('message_text_error_ncComplete') ||
            '存在尚未填写NC编码的产品，请检查！'
        )
        return
      }
      const params = { noticeOrderCode: this.noticeOrderCode }
      this.loadingOpen()
      const res = await this.$api
        .noticeOrderGoodsNcCompleteApi(params)
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(
          this.$l('INDEX.message_text_operationFailed') || '操作失败！'
        )
        return
      }
      this.$message({
        showClose: true,
        message:
          this.$l('INDEX.message_text_operationSucceeded') || '操作成功！',
        type: 'success',
      })
      this.$emit('reload')
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss" scoped>
.order-goods-table-header {
  display: flex;
  justify-content: space-between;
}
</style>
